import { CmsComponentGroups, IdtComponentCmsDefinition } from 'shared/idt-components/idt-components-cms.model';
import { IdtComponentRole } from 'shared/models/idt-components/idt-component-role.models';
import { IdtComponentDefinition } from 'shared/models/idt-components/idt-component.models';

import { SliceStylesDefaultValues } from 'extensions/core/slice-base/models/slice-base.settings.model';
import { initialSliceSlotState } from 'extensions/core/slice-base/models/slice-slot.settings.model';

import { SliceMarqueeSettings } from './settings/slice-marquee-settings.model';


export const SliceMarqueeDefinition: IdtComponentDefinition = {
  id: 'slice-marquee',
  role: IdtComponentRole.Slice,
  numSlots: 1,
  defaultSlot: 1
};

export const SLICE_MARQUEE_DEFAULT_SPEED = 5;

export const SliceMarqueeCmsDefinition: IdtComponentCmsDefinition = {
  name: 'Marquesina',
  group: CmsComponentGroups.Components,
  availablePlatforms: ['web'],
  initialSettings: (): SliceMarqueeSettings => ({
    general: {
      swipeDirection: 'left',
      numSlots: 1,
      speed: SLICE_MARQUEE_DEFAULT_SPEED,
      speedMobile: SLICE_MARQUEE_DEFAULT_SPEED,
      accessibility: {
        showControls: false,
        controlButtonPosition: 'right',
        buttonPauseText: '',
        buttonPlayText: ''
      }
    },
    slots: [
      { ...initialSliceSlotState }
    ],
    styles: {
      ...SliceStylesDefaultValues,
      primaryLightColor: '#000',
      secondaryLightColor: '#CCC',
      primaryDarkColor: '#FFF',
      secondaryDarkColor: '#CCC'
    }
  })
};
